import { render, staticRenderFns } from "./ViewStockItem.vue?vue&type=template&id=4a7437f5&scoped=true&"
import script from "./ViewStockItem.vue?vue&type=script&lang=js&"
export * from "./ViewStockItem.vue?vue&type=script&lang=js&"
import style0 from "./ViewStockItem.vue?vue&type=style&index=0&id=4a7437f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7437f5",
  null
  
)

export default component.exports